import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from "react"
import SButton from "components/Common/Button"
import TabJacket from "./TabJacket"
import TabTourses from "./TabTourses"
import BranchesAPI from "helpers/branches_backend_helper"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { getProductCategoryListAPI } from "helpers/product_category_helper"
import { getProductListAPI, getProductTgType } from "helpers/product_helper"
import { getOrderSheetByIdAPI } from "helpers/order_sheet"
import CompanyAPI from "helpers/company_backend_helper"
import { getFabricTradingListAPI } from "helpers/fabric_trading_company_resource"
import {
  getFabricListAPI,
  getFabricRankAPI,
  getFabricSeasonListAPI,
  getFabricYearListAPI,
} from "helpers/fabric_resource"
import { getCommonTaxAPI } from "helpers/common"
import {
  getFileCategoryApi,
  postOrderAPI,
  postOrderRepairAPI,
} from "helpers/order"
import { useHistory } from "react-router-dom"
import Repair from "../Repair"
import { defaultValue } from "../Repair/default-value"
import Breadcrumb from "components/Common/Breadcrumb"
import TabHandwritingNotebook from "./TabHandwritingNotebook"
import Skeleton from "react-loading-skeleton"
import { useDispatch } from "react-redux"
import { getSheets } from "store/canvas/action"
import AsyncSelect from "react-select/async"
import Select, { defaultTheme } from "react-select"
import "./style.css"
import FileManagerModal from "components/Common/FileManagerModal"
import debounce from "debounce-promise"
import { toast } from "react-toastify"
import moment from "moment"
const debouncegetFabricAPI = debounce(getFabricListAPI, 1000)

function Orders() {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [tab, setTab] = React.useState([])
  const [activeTab, setActiveTab] = React.useState(0)
  const getCanvasRef = useRef()
  const getRepairCanvasRef = useRef()
  const [data, setData] = React.useState([])
  const initialPayload = {
    storeId: 0,
    customerId: 0,
    type: "Bespoke",
    productId: 0,
    orderDate: new Date().toISOString().slice(0, 10),
    guest: false,
    guestName: "",
    fabricCompanyId: "",
    year: 0,
    seasonId: "",
    fabricId: "",
    fittingDate: "",
    basting: true,
    jacket: {
      scale: 0,
      priceWithoutTax: 0,
      priceTaxIncluded: 0,
      deliveryMethod: "",
      sample: false,
      // scheduledDeliveryDate: "2023-02-27",
      tg: "",
      specifications: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "",
            },
          ],
        },
      ],
      dimensions: [
        {
          formId: 0,
          sequence: 0,
          gaugeDimensions: "",
          correctionValue: "",
          lawToGoUp: "",
        },
      ],
      otherDimensions: [
        {
          formId: 0,
          sequence: 0,
          answer: "",
        },
      ],
    },
    pants: {
      scale: 0,
      priceWithoutTax: 0,
      priceTaxIncluded: 0,
      deliveryMethod: "",
      sample: false,
      // scheduledDeliveryDate: "2023-02-27",
      tg: "",
      button: "",
      threadColor: "",
      specifications: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "",
            },
          ],
        },
      ],
      dimensions: [
        {
          formId: 0,
          sequence: 0,
          nude: "",
          correctionValue: "",
          riseDimension: "",
        },
      ],
      corrections: [
        {
          formId: 0,
          sequence: 0,
          answers: [
            {
              sequence: 0,
              answer: "",
            },
          ],
        },
      ],
    },
    files: [],
  }
  const defaultSelect = { label: "", value: "" }
  const [customerOptions, setCustomerOptions] = useState([])
  const [deliveryMethodOptions, setDeliveryMethodOptions] = useState([
    { label: "ご来店", value: "ご来店" },
    { label: "ご配送", value: "ご配送" },
    {
      label: "次回オーダー会",
      value: "次回オーダー会",
    },
  ])
  // product & category state/value for select
  const [categoryValue, setCategoryValue] = useState(defaultSelect)
  const [productValue, setProductValue] = useState("")
  const [deliveryMethodValue, setDeliveryMethodValue] = useState(defaultSelect)
  const [payload, setPayload] = useState(initialPayload)
  const [orderSheets, setOrderSheets] = useState(null)
  const [branchValue, setBranchValue] = React.useState(defaultSelect)
  const [customerValue, setCustomerValue] = useState(defaultSelect)
  const [fabricTradingValue, setFabricTradingValue] = useState(defaultSelect)
  const [fabricValue, setFabricValue] = useState(defaultSelect)
  const [fabricOption, setFabricOption] = useState([])
  const [yearOption, setYearOption] = useState([])
  const [yearValue, setYearValue] = useState(defaultSelect)
  const [seasonOption, setSeasonOption] = useState([])
  const [seasonValue, setSeasonValue] = useState(defaultSelect)
  const [rank, setRank] = useState(null)
  const [tax, setTax] = useState(0)
  const [pantsCorrections, setPantsCorrections] = useState([])
  const [pantsSpecifications, setPantsSpecifications] = useState([])
  const [pantsDimensions, setPantsDimensions] = useState([])
  const [jacketSpecifications, setJacketSpecificatons] = useState([])
  const [jacketDimensions, setJacketDimensions] = useState([])
  const [jacketODimensions, setJacketODimensions] = useState([])
  const [pantsDeliveryMethod, setPantsDeliveryMethod] = useState(defaultSelect)
  const [jacketDeliveryMethod, setJacketDeliveryMethod] =
    useState(defaultSelect)
  const [guestHidden, setGuestHidden] = useState(1)
  const [canvas, setCanvas] = useState([])
  const [repairCanvas, setRepairCanvas] = useState([])
  const [productPlaceholder, setProductPlaceholder] = useState("商品名") // "Repair"
  const [productSelectDisabled, setProductSelectDisabled] = useState(true)
  const [trigger, setTriger] = useState(0)
  const [fileCategoryOptions, setFileCategoryOptions] = useState([])
  const [fileCategoryValue, setFileCategoryValue] = useState("")
  const [modalOpen, setModalOpen] = useState(false)
  const openModal = useCallback(() => setModalOpen(true), [])
  const closeModal = useCallback(() => setModalOpen(false), [])
  const [file, setFile] = useState(null)
  const resetState = () => {
    setBranchValue(defaultSelect)
    setCustomerValue(defaultSelect)
    setFabricTradingValue(defaultSelect)
    setFabricValue(defaultSelect)
    setFabricOption([])
    setYearOption([])
    setYearValue(defaultSelect)
    setSeasonOption([])
    setSeasonValue(defaultSelect)
    setRank(null)
    //  setTax(0);
    setPantsCorrections([])
    setPantsSpecifications([])
    setPantsDimensions([])
    setJacketSpecificatons([])
    setJacketDimensions([])
    setJacketODimensions([])
    setActiveTab(0)
  }

  console.log("payload")
  console.log(payload)

  // product & category select handler
  const loadCategory = async inputValue => {
    let params = {
      keyword: inputValue,
    }
    let res = await getProductCategoryListAPI(params)
    res.data.push({ id: "Repair", name: "お直し" })
    return res.data
      .map(val => {
        return { label: val.name, value: val.id }
      })
      .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
  }
  const fetchProduct = async params => {
    try {
      let res = await getProductListAPI(params)
      let _data = []
      res.data.forEach(v => {
        _data.push({
          value: v.id,
          label: v.productName,
        })
      })
      setData(_data)
    } catch (error) {
      console.log("error: ", error.response)
    }
  }
  const reconstructPayload = data => {
    return {
      jacket: {
        ...data.jacket,
        specifications: data.jacket?.specifications
          ? data.jacket.specifications
              // .filter(items => items.formId)
              .map(item => ({
                formId: item.formId || 0,
                sequence: item.sequence,
                answers: item.labels?.length
                  ? item.labels.map(label => ({
                      sequence: label.sequence,
                      answer: label.label,
                    }))
                  : [],
              }))
          : [],
        dimensions: data.jacket?.dimensions
          ? data.jacket.dimensions
              .filter(items => items.formId)
              .map(item => ({
                formId: item.formId,
                sequence: item.sequence,
                gaugeDimensions: "",
                correctionValue: "",
                lawToGoUp: "",
              }))
          : [],
        otherDimensions: data.jacket?.otherDimensions
          ? data.jacket.otherDimensions
              .filter(items => items.formId)
              .map(item => ({
                formId: item.formId,
                sequence: item.sequence,
                answer: "",
              }))
          : [],
      },
      pants: {
        ...data.pants,
        specifications: data.pants?.specifications
          ? data.pants.specifications
              // .filter(items => items.formId)
              .map(item => ({
                formId: item.formId || 0,
                sequence: item.sequence,
                answers: item.labels?.length
                  ? item.labels.map(label => ({
                      answer: label.label,
                      sequence: label.sequence,
                    }))
                  : [],
              }))
          : [],
        dimensions: data.pants?.dimensions
          ? data.pants.dimensions
              .filter(items => items.formId)
              .map(item => ({
                formId: item.formId,
                sequence: item.sequence,
                nude: "",
                correctionValue: "",
                riseDimension: "",
              }))
          : [],
        corrections: data.pants?.corrections
          ? data.pants.corrections
              .filter(items => items.formId)
              .map(item => ({
                formId: item.formId,
                sequence: item.sequence,
                answers: item.labels.map(label => ({
                  sequence: label.sequence,
                  answer: label.label,
                })),
              }))
          : [],
      },
    }
  }
  const getOrderSheets = async id => {
    setIsLoading(true)
    try {
      const res = await getOrderSheetByIdAPI(id)
      setOrderSheets({ ...res.data, productId: id })
      const _tab = []
      res.data.forms.forEach((v, i) => {
        _tab.push({ index: i, label: v })
      })
      const handwritingTab = {
        index: _tab[_tab.length - 1].index + 1,
        label: "手書きノート",
      }
      _tab.push(handwritingTab)
      setTab(_tab)
      const _payload = { ...payload }
      _payload.productId = id
      // we need to reinitialize the payload based on new data we just received
      const { jacket, pants } = reconstructPayload(res.data)
      setPayload({
        ..._payload,
        productId: id,
        jacket: {
          ..._payload.jacket,
          dimensions: jacket.dimensions,
          specifications: jacket.specifications,
          otherDimensions: jacket.otherDimensions,
        },
        pants: {
          ..._payload.pants,
          specifications: pants.specifications,
          dimensions: pants.dimensions,
          corrections: pants.corrections,
        },
      })
      setIsLoading(false)
    } catch (error) {
      console.error(error)
      setIsLoading(false)
    }
  }
  const handleCategorySelect = value => {
    if (!value) {
      setCategoryValue(defaultSelect)
      return
    }
    resetState()

    if (value.value === "Repair") {
      setProductValue("")
      setPayload(defaultValue)
      setProductPlaceholder("お直し")
      setProductSelectDisabled(true)
    } else {
      setPayload(initialPayload)
      setProductValue("")
      setProductPlaceholder("商品名")
      setProductSelectDisabled(false)
    }
    localStorage.removeItem("jsonCanvas")
    setCategoryValue(value)
  }
  const handleProductSelect = value => {
    if (!value) {
      // setProductValue(defaultSelect)
      return
    }
    setProductValue(value)
    if (value.value !== "Repair") {
      getOrderSheets(value?.value)
      setPayload({ ...initialPayload, productId: value.value })
      // setOrderSheets({...initialPayload, productId: value.value})
    }
  }
  useEffect(() => {
    getSheet()
  }, [orderSheets])
  const getSheet = () => {
    dispatch(getSheets(orderSheets?.id))
  }
  useEffect(() => {
    let params = {
      categoryId: categoryValue?.value,
    }
    if (categoryValue?.value !== "Repair") {
      fetchProduct(params)
    } else {
      fetchProduct("")
    }
  }, [categoryValue])

  // 1. Select handler from branch API to get "storeId"
  const loadBranch = async inputValue => {
    let params = {
      keyword: inputValue,
    }
    let res = await BranchesAPI.getList(params)
    return res.data
      .map(val => {
        return { label: val.branchName, value: val.id, org: val }
      })
      .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
  }
  // 2. Select handler from customer API
  const loadCustomer = async (inputValue = "") => {
    let params = {
      branchId: payload.storeId,
      keyword: inputValue,
    }
    let res = await CompanyAPI.getList(params)
    const _customers = res.data
      .map(val => {
        return { label: `${val.customerName}`, value: val.id }
      })
      .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
    return _customers
  }
  // 3. Select handler from fabric trading API
  // useEffect(() => {
  //   if (branchValue) loadCustomer("")
  // }, [branchValue])
  const loadFabricTrading = async inputValue => {
    let res = await getFabricTradingListAPI()
    return res.data
      .map(val => {
        return { label: val.name, value: val.id, org: val }
      })
      .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
  }
  // 4. Select handler from fabric/material API

  const loadFabric = async (inputValue = "") => {
    const params = {
      fabricCompanyId: payload.fabricCompanyId,
      year: payload.year,
      keyword: inputValue,
    }
    const res = await debouncegetFabricAPI(inputValue === "" ? "" : params)
    return res.data
      .map(item => ({
        label: `${item.number} ${item.brand} (${item.bunch}) `,
        value: item.id,
        org: item,
      }))
      .filter(item =>
        item.label.toLowerCase().includes(inputValue.toLowerCase())
      )
  }

  // useEffect(() => {
  //   let params = {
  //     fabricCompanyId: payload.fabricCompanyId,
  //     year: payload.year,
  //   }
  //   loadFabric(params)
  // }, [payload.fabricCompanyId, payload.year])
  // 5. Select handler from year API
  const loadFabricYear = () => {
    getFabricYearListAPI(payload.fabricCompanyId).then(res => {
      let _opt = []
      res.data.forEach(v => {
        _opt.push({ label: v, value: v, org: v })
      })
      setYearOption(_opt)
    })
  }
  useEffect(() => {
    if (payload.fabricCompanyId) {
      loadFabricYear()
    }
  }, [payload.fabricCompanyId])
  // 6. Select handler from season API
  const loadFabricSeason = () => {
    getFabricSeasonListAPI(payload.fabricId, payload.year)
      .then(res => {
        let _opt = []
        res.data.forEach(v => {
          _opt.push({
            label: `${v.seasonName} (${v.seasonCode})`,
            value: v.seasonId,
          })
        })
        setSeasonOption(_opt)
      })
      .catch(err => {
        console.log("err: ", err.response)
      })
  }
  useEffect(() => {
    if (payload.fabricId && payload.year) {
      loadFabricSeason()
    }
  }, [fabricValue, yearValue])
  // 7. handle rank API
  const loadRank = () => {
    getFabricRankAPI(payload.fabricId, payload.year, payload.seasonId).then(
      res => {
        setRank(res.data)
      }
    )
  }
  useEffect(() => {
    if (payload.fabricId && payload.year && payload.seasonId) {
      loadRank()
    }
  }, [payload.fabricId, payload.year, payload.seasonId])
  // 8. fetch tax
  const fetchTax = () => {
    getCommonTaxAPI().then(res => {
      setTax(res.data.tax)
    })
  }
  useEffect(() => {
    fetchTax()
    loadFileCategory()
  }, [])
  const loadFileCategory = async () => {
    try {
      const { data } = await getFileCategoryApi()
      const _list = data.map(item => ({
        label: item.name,
        value: item.id,
      }))
      setFileCategoryOptions(_list)
    } catch (error) {
      console.error("Error getting file category: ", error)
    }
  }
  const loadTgTypes = async (tg, [paramType, payloadType]) => {
    // 上着
    // トラウザーズ
    try {
      const { data } = await getProductTgType(payload.productId, tg, paramType)
      if (!data.length) return
      const _dimensions = [...payload[payloadType]?.dimensions].map(item => ({
        ...item,
        nude: parseFloat(
          data.find(_item => item.formId === _item.formId).defaultValue
        ),
        gaugeDimensions: parseFloat(
          data.find(_item => item.formId === _item.formId).defaultValue
        ),
      }))
      setPayload({
        ...payload,
        [payloadType]: {
          ...payload[payloadType],
          dimensions: _dimensions,
        },
      })
    } catch (error) {
      console.error("Error getting tg types: ", error)
    }
  }
  // useEffect(() => {}, [])
  const stateHandlers = {
    storeId: v => {
      setBranchValue(v)
      CompanyAPI.getList({ branchId: v.value }).then(res => {
        setCustomerOptions(
          res.data.map(cust => ({
            label: cust.customerName,
            value: cust.id,
          }))
        )
      })
    },
    customerId: v => setCustomerValue(v),
    fabricId: v => setFabricValue(v),
    fabricCompanyId: v => {
      setFabricTradingValue(v)
      if (payload.year) {
        // console.log("loading fabrics")
        const params = {
          fabricCompanyId: v.value,
          year: payload.year,
        }
        getFabricListAPI(params).then(res => {
          setFabricOption(
            res.data.map(item => ({
              label: `${item.number} ${item.brand} (${item.bunch})`,
              value: item.id,
              org: item,
            }))
          )
        })
      }
    },
    year: v => {
      setYearValue(v)
      if (payload.fabricCompanyId) {
        const params = {
          fabricCompanyId: payload.fabricCompanyId,
          year: v.value,
        }
        getFabricListAPI(params).then(res => {
          setFabricOption(
            res.data.map(item => ({
              label: ` ${item.number} ${item.brand} (${item.bunch})`,
              value: item.id,
              org: item,
            }))
          )
        })
      }
    },
    seasonId: v => setSeasonValue(v),
  }
  const handleCommonInput = (e, name, param) => {
    const _payload = { ...payload }
    switch (name) {
      case "storeId":
      case "customerId":
      case "fabricCompanyId":
      case "fabricId":
      case "year":
      case "seasonId": {
        // in case of clearing select, we simply reset the state
        if (!e) {
          stateHandlers[name](defaultSelect)
          _payload[name] = ""
          setPayload(_payload)
        } else {
          _payload[name] = e.value
          setPayload(_payload)
          stateHandlers[name](e)
          // we might change this later, hiding 'guest' input
          // when certain storeId is selected
          if (name === "storeId" && e.value && e.value === 1) setGuestHidden(0)
          else setGuestHidden(1)
        }
        // break
        return
      }
      case "memo": {
        _payload[name] = e.target.value
        break
      }
      case "guestName": {
        _payload[name] = e.target.value
        break
      }
      case "fittingDate":
      case "orderDate": {
        // const _d = new Date(e).toISOString().slice(0, 10)
        _payload[name] = moment(e).format("YYYY-MM-DD")
        break
      }
      case "type": {
        _payload[name] = e.target.value
        break
      }
      case "guest": {
        const { checked } = e.target
        _payload[name] = checked
        break
      }
      case "basting": {
        _payload[name] = param
        break
      }
      case "fileCategoryName": {
        if (!e) setFileCategoryValue("")
        setFileCategoryValue(e)
        break
      }
      case "fileCategory": {
        setFile(e.target.files[0])
        break
      }
    }
    setPayload(_payload)
  }
  const handlePantsInput = (e, name, param) => {
    const _payload = { ...payload }
    switch (name) {
      case "scale": {
        const { value } = e.target
        _payload.pants[name] = name === "scale" ? +value : value
        break
      }
      case "priceWithoutTax": {
        const value = parseInt(e) || 0
        let priceTaxIncluded = 0
        if (value) {
          priceTaxIncluded = value + value * 0.1
        }

        _payload["pants"]["priceWithoutTax"] = value
        _payload["pants"]["priceTaxIncluded"] = priceTaxIncluded
        break
      }

      case "deliveryMethod": {
        _payload.pants[name] = e.value
        setPantsDeliveryMethod(e)
        break
      }
      case "sample": {
        _payload.pants[name] = e.target.checked
        break
      }
      case "scheduledDeliveryDate": {
        let d = ""
        if (e[0]) {
          // d = new Date(e[0]).toISOString().slice(0, 10)
          d = moment(e[0]).format("YYYY-MM-DD")
        }
        _payload.pants[name] = d
        break
      }
      case "tg": {
        _payload.pants[name] = e.target.value
        break
      }
      case "button": {
        _payload.pants[name] = e.target.value
        break
      }
      case "threadColor": {
        _payload.pants[name] = e.target.value
        break
      }
      case "specifications":
      case "dimensions":
      case "corrections":
        _payload.pants[name][param] = e
        break
    }
    setPayload(_payload)
  }
  const handleJacketInput = (e, name, param) => {
    const _payload = { ...payload }
    const { value } = e?.target || ""
    switch (name) {
      case "scale": {
        _payload.jacket[name] = name === "scale" ? +value : value
        break
      }
      case "priceWithoutTax": {
        const value = parseInt(e) || 0
        let priceTaxIncluded = 0
        if (value) {
          priceTaxIncluded = value + value * 0.1
        }

        _payload["jacket"]["priceWithoutTax"] = value
        _payload["jacket"]["priceTaxIncluded"] = priceTaxIncluded
        break
      }
      case "scheduledDeliveryDate": {
        let d = ""
        if (e[0]) {
          // d = new Date(e[0]).toISOString().slice(0, 10)
          d = moment(e[0]).format("YYYY-MM-DD")
        }
        _payload.jacket[name] = d
        break
      }
      case "deliveryMethod": {
        _payload.jacket[name] = e.value
        setJacketDeliveryMethod(e)
        break
      }
      case "sample": {
        _payload.jacket[name] = e.target.checked
        break
      }
      case "tg": {
        _payload.jacket[name] = e.target.value
        break
      }
      case "specifications":
      case "dimensions":
      case "otherDimensions": {
        _payload.jacket[name][param] = e
        break
      }
    }
    setPayload(_payload)
  }
  const onTgBlur = (e, type) => {
    const _tg = e?.target?.value
    if (!_tg) return
    return loadTgTypes(_tg, type)
  }
  const onAddFile = () => {
    // Early exit when either fileCategory or file is empty
    if (!fileCategoryValue?.value || !file) return
    // Define the object required for the payload
    const _fileInfo = {
      categoryId: fileCategoryValue.value,
      categoryName: fileCategoryValue.label,
      fileName: file.name,
      file: file, // function (e) { setFile(e.target.files[0]) }
    }
    const _files = [...payload.files, _fileInfo]
    const _payload = { ...payload, files: _files }
    setPayload(_payload)

    // will show success add file temporary until save to api
    let messageSuccessAddFile = (
      <p>
        ファイルはまだ保存されていません。
        <br />
        ポップアップを閉じて「保存」ボタンをクリックして下さい。
      </p>
    )
    toast.warning(messageSuccessAddFile)

    setTimeout(() => {
      setFileCategoryValue("")
      setFile(null)
      const fileInputEl = document?.getElementById("fileInput")
      fileInputEl.value = null
    }, 10)
  }
  const onDeleteFile = idx => {
    const _files = [...payload.files]
    _files.splice(idx, 1)
    setPayload({ ...payload, files: _files })

    // will show success delete file temporary until save to api
    let messageSuccessDeleteFile = (
      <p>
        ファイルはまだ削除されていません。
        <br />
        ポップアップを閉じて「保存」ボタンをクリックして下さい。
      </p>
    )
    toast.warning(messageSuccessDeleteFile)
  }

  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmitPress = () => {
    setIsSubmitting(true)

    if (categoryValue.value === "Repair") {
      setActiveTab(0)
      setTimeout(() => {
        setActiveTab(1)
      }, 500)
    } else {
      setActiveTab(tab.length - 1)
    }
    setTimeout(() => {
      onSubmit()
    }, 1000)
  }
  const onSubmit = async () => {
    setTriger(trigger => trigger + 1)
    try {
      let data
      if (categoryValue.value === "Repair") {
        const getCanvas = await getRepairCanvasRef.current.saveCanvas()

        let form = { ...payload }
        let handwritings

        if (getCanvas.details) {
          handwritings = getCanvas
        } else {
          handwritings = {
            details: [],
          }
        }

        form = {
          ...payload,
          storeId: payload?.storeId?.value ?? "",
          // customerId: payload?.customerId?.value ?? "",
          productId: productValue?.value ?? "",
          handwriting: handwritings,
        }

        setTimeout(async () => {
          data = await postOrderRepairAPI(form)
          setIsSubmitting(false)
          if (data.status === 200) {
            setIsSubmitting(false)
            toast.success(`保存しました。`)
            setTimeout(() => {
              history.push("/orders")
            }, 500)
          }
        }, 500)
      } else {
        const formData = new FormData()
        const config = {
          "Content-Type": "multipart/formdata",
        }
        for (const key in payload) {
          switch (key) {
            case "jacket":
            case "pants": {
              for (const _key in payload[key]) {
                switch (_key) {
                  case "specifications":
                  case "dimensions":
                  case "otherDimensions":
                  case "corrections": {
                    if (payload[key][_key].length) {
                      payload[key][_key].forEach((item, idx) => {
                        for (const __k in item) {
                          if (__k === "answers") {
                            item[__k].forEach((_item, _idx) => {
                              for (const ___k in _item) {
                                const fKey = `${key}.${_key}[${idx}].${__k}[${_idx}].${___k}`
                                const fVal = `${_item[___k]}`
                                formData.append(fKey, fVal || "")
                              }
                            })
                          } else {
                            const fKey = `${key}.${_key}[${idx}].${__k}`
                            const fVal = item[__k]
                            formData.append(fKey, fVal || "")
                          }
                        }
                      })
                    }
                    break
                  }
                  default: {
                    formData.append(`${key}.${_key}`, payload[key][_key] || "")
                  }
                }
              }
              break
            }
            case "files": {
              if (payload[key].length) {
                payload[key].forEach((item, idx) => {
                  for (const _k in item) {
                    formData.append(`${key}[${idx}].${_k}`, item[_k] || "")
                  }
                })
              }
              break
            }
            default: {
              formData.append(key, payload[key] || "")
            }
          }
        }
        const getCanvas = await getCanvasRef.current.saveCanvas()
        let handwritings

        setTimeout(async () => {
          if (getCanvas.details) {
            handwritings = getCanvas
          } else {
            handwritings = {
              details: [],
            }
          }
          if (handwritings.details) {
            handwritings.details.forEach((dtl, idx) => {
              formData.append(
                `handwriting.details[${idx}].json`,
                JSON.stringify(dtl.json || "[]")
              )
              formData.append(
                `handwriting.details[${idx}].image`,
                dtl.image || ""
              )
            })
          }

          console.log(handwritings)
          console.log(getCanvas?.canvas.length)

          // debugging;
          // for (const [key, value] of formData.entries()) {
          //   console.log({ [key]: value })
          // }
          // debugging;
          console.log("run")
          console.log(handwritings)
          data = await postOrderAPI(formData, config)

          if (data.status === 200) {
            setIsSubmitting(false)
            toast.success(`保存しました。`)
            setTimeout(() => {
              history.push("/orders")
            }, 500)
          }
        }, getCanvas?.canvas.length * 1000)
      }
      // console.log("submitting")
      // return
    } catch (error) {
      setIsSubmitting(false)

      for (let i in error?.response?.data.errors) {
        for (const [key, value] of Object.entries(
          Object.entries(error?.response?.data?.errors[i])
        )) {
          toast.error(`${value[0]}: ${value[1]}`)
        }
      }
    }
  }
  const tabConfig = {
    orderSheets,
    payload,
    // branch
    loadBranch,
    branchValue,
    // customer
    loadCustomer,
    customerValue,
    // fabric trading
    loadFabricTrading,
    fabricTradingValue,
    // fabric
    loadFabric,
    fabricOption,
    fabricValue,
    // year
    yearOption,
    yearValue,
    // season
    seasonOption,
    seasonValue,
    // rank
    rank,
    handleCommonInput,
    handleJacketInput,
    handlePantsInput,
    pantsDimensions,
    pantsCorrections,
    setPantsCorrections,
    pantsSpecifications,
    setPantsSpecifications,
    jacketDimensions,
    jacketODimensions,
    jacketSpecifications,
    setJacketSpecificatons,
    deliveryMethodOptions,
    deliveryMethodValue,
    customerOptions,
    pantsDeliveryMethod,
    setPantsDeliveryMethod,
    jacketDeliveryMethod,
    setJacketDeliveryMethod,
    guestHidden,
    setGuestHidden,
    onTgBlur,
  }
  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"新規受注登録"} breadcrumbList={[]} />
          <Card>
            <CardBody>
              <Row>
                <Col style={{ placeSelf: "center" }} xl={1} md={2}>
                  商品選択
                </Col>
                <Col sm={3}>
                  <AsyncSelect
                    className="select2-selection"
                    placeholder={"商品カテゴリ"}
                    loadOptions={loadCategory}
                    cacheOptions={true}
                    defaultOptions
                    onChange={handleCategorySelect}
                    isClearable
                  />
                </Col>
                <Col sm={3}>
                  <Select
                    options={data}
                    className="select2-selection"
                    onChange={handleProductSelect}
                    isClearable
                    value={productValue}
                    placeholder={productPlaceholder}
                    isDisabled={productSelectDisabled}
                  />
                </Col>
                <Col
                  xl={5}
                  md={12}
                  className="d-flex justify-content-end gap-2 mt-4 mt-xl-0"
                >
                  {(productValue?.value ||
                    categoryValue?.value === "Repair") && (
                    <Fragment>
                      <SButton
                        className="button"
                        style={{ width: 150 }}
                        onClick={openModal}
                      >
                        ファイル管理
                      </SButton>
                      <SButton
                        className="button"
                        style={{ width: 150 }}
                        onClick={onSubmitPress}
                        loading={isSubmitting}
                      >
                        保存
                      </SButton>
                    </Fragment>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          {categoryValue.value === "Repair" ? (
            <Repair
              form={payload}
              config={tabConfig}
              setForm={setPayload}
              setCanvas={e => setRepairCanvas(e)}
              trigger={trigger}
              ref={getRepairCanvasRef}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
            />
          ) : !productValue?.value || productValue?.value === "" ? (
            <div className="d-flex my-3" style={{ height: "200px" }} />
          ) : isLoading ? (
            <Skeleton count={8} />
          ) : (
            <>
              <div className="d-flex my-3">
                {tab.map(v => {
                  return (
                    <SButton
                      style={{ width: 150, borderRadius: 0 }}
                      className={
                        activeTab === v.index ? "button-active" : "button"
                      }
                      key={v.index}
                      onClick={() => setActiveTab(v.index)}
                    >
                      {v.label}
                    </SButton>
                  )
                })}
              </div>
              <div className="mt-4">
                {tab[activeTab]?.label === "トラウザーズ" ? (
                  <TabTourses config={tabConfig} />
                ) : tab[activeTab]?.label === "上着" ? (
                  <TabJacket config={tabConfig} />
                ) : (
                  <TabHandwritingNotebook
                    config={tabConfig}
                    setCanvas={v => setCanvas(v)}
                    ref={getCanvasRef}
                    trigger={trigger}
                  />
                )}
              </div>
            </>
          )}
        </Container>
      </div>
      <FileManagerModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        payload={payload}
        fileCategoryOptions={fileCategoryOptions}
        fileCategoryValue={fileCategoryValue}
        onDeleteFile={onDeleteFile}
        onAddFile={onAddFile}
        handleInput={handleCommonInput}
      />
    </Fragment>
  )
}
export default Orders
